<h2 mat-dialog-title>Search Error Details</h2>
<mat-dialog-content>
  <ul>
    @for (error of searchErrors(); track $index) {
      <li>{{ error }}</li>
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-button
    mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>
